import store from '@/store';

const showBreadcrumbs = () => {
    store.dispatch(`preferences/setShowBreadcrumbs`, true);
};

export default showBreadcrumbs;
